<template>
  <div>
    <div class="logo--wrapper" v-if="showFixedHeader">
      <router-link to="/">
        <img
          src="../../assets/gemnote_logo_pebble.png"
          alt="gemnote-logo"
          class="logo--wrapper--img"
        />
      </router-link>
    </div>
    <div class="black-band" :class="{ 'is-fixed': showFixedHeader }">
      <h5 class="inter" v-if="!isSuccess">
        {{ getTitle }}
      </h5>
      <h5 class="inter" v-else>
        {{ getTitle }}
      </h5>
      <div v-if="!isShipping">
        <p>{{ sectionDescription }}</p>
        <p v-if="specialInstruction">{{ specialInstruction }}</p>
      </div>

      <p v-if="isShipping" class="shipping-banner">
        We’ve shipped your order.
        <span class="track-text" v-if="trackingUrl"
          ><a :href="trackingUrl" target="_blank" rel="noopener noreferrer"
            >Track your package</a
          >
        </span>
        <span class="track-text" v-if="trackingNo"
          >Tracking No: {{ trackingNo }}</span
        >
      </p>

      <a
        v-if="groupOrderDetails.groupOrderAttachment"
        :href="groupOrderDetails.groupOrderAttachment.url"
        target="_blank"
        rel="noopener noreferrer"
        class="chart-link"
      >
        <p class="black-band__chart inter">
          View size charts
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="10"
              fill="none"
            >
              <path
                d="M8.49996 1.31055H1V9.3105h7.99996V5.81052"
                stroke="#fff"
              />
              <path
                d="M12.9015 1.0466c.0253-.13574-.0642-.26628-.2-.29158L10.4896.34277c-.1357-.0253-.2663.06423-.2916.19997-.0253.13573.0643.26627.2.29157l1.9661.36644-.3664 1.96615c-.0253.13573.0642.26627.2.29157.1357.0253.2662-.06423.2915-.19996l.4123-2.21191ZM7.00272 5.18078l5.79438-3.97381-.2828-.41235-5.79437 3.97382.28279.41234Z"
                fill="#fff"
              />
            </svg>
          </span>
        </p>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'GroupOrderHeaderBand',
  props: {
    sectionDescription: {
      type: String,
      default:
        'Please select your choice(s) below. If there is more than 1 option, please select from the dropdown.'
    },
    specialInstruction: {
      type: String,
      default: ''
    },
    isSuccess: {
      type: Boolean,
      default: false
    },
    showFixedHeader: {
      type: Boolean,
      default: false
    },
    isShipping: {
      type: Boolean,
      default: false
    },
    trackingUrl: {
      type: String,
      default: '',
      required: false
    },
    trackingNo: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    getTitle() {
      if (this.isSuccess) {
        return `Thank you for submitting your information.`
      } else if (this.isShipping) {
        return `Get excited! Your order is on its way.`
      } else {
        if (this.groupOrderDetails.redemptionTitle !== null) {
          return this.groupOrderDetails.redemptionTitle
        }

        return `${this.createdBy}'s Redemption Page for ${this.teamName}.`
      }
    },
    createdBy() {
      return this.groupOrderDetails.createdByUser.name
    },
    teamName() {
      return this.groupOrderDetails.teamName
    },
    ...mapState({
      groupOrderDetails: state => state.groupOrder.groupOrderDetails
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';
.black-band {
  display: flex;
  padding: 2rem 5rem;
  flex-direction: column;
  color: $main-white;
  background: $onyx;
  text-align: justify;

  &.is-fixed {
    position: relative;
    top: 6.8rem;
  }

  h5 {
    font-size: $bigger-title-size;
    margin: 0.3rem 0.3rem;
  }

  p {
    margin: 0.3rem 0.3rem;
    opacity: 0.7;
  }

  a {
    text-decoration: none;
  }
  .black-band__chart {
    text-decoration: underline;
    margin-top: 8px;
  }

  .chart-link {
    color: white;
    display: inline-block;
    white-space: initial;
  }
  .shipping-banner {
    color: #ffffff;
  }
  .track-text {
    color: #ffffff;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
  }
}

.logo--wrapper {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #f5f2ee;
  padding: 1.875rem 0;
  border-bottom: 2px solid #24292c;
  margin-bottom: 3rem;
  z-index: 9999;

  .logo--wrapper--img {
    width: 50px;
    margin: 0px auto;
  }
}

@media (max-width: 575.98px) {
  .black-band {
    padding: 2rem 1rem;
    text-align: left;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .black-band {
    padding: 2rem 1.5rem;
    text-align: left;
  }
}
</style>
